<template>
  <v-row class="heading-row">
    <v-col cols="12" class="heading-column">
      <div class="heading-wrapper">
        <h2 class="heading-title">{{ title }}</h2>
        <p class="heading-text">
          {{ paragraph }}
          <span v-if="subText" class="sub-text">{{ subText }}</span>
        </p>
      </div>
    </v-col>
  </v-row>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
  paragraph: {
    type: String,
    required: true,
  },
  subText: {
    type: String,
    default: '',
  },
});
</script>

<style scoped>
/* Base Styles */
.heading-row {
  margin-bottom: 4rem;
}

.heading-column {
  padding: 0;
}

.heading-wrapper {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}

.heading-title {
  font-size: 2.5rem;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 1.5rem;
  background: linear-gradient(90deg, hwb(231 2% 45% / 0.678), #205f92d8);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  letter-spacing: -0.5px;
}

.heading-text {
  font-size: 1.25rem;
  line-height: 1.6;
  color: rgba(0, 0, 0, 0.8);
  margin-bottom: 0.5rem;
}

.sub-text {
  display: block;
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 1rem;
  font-weight: 500;
}


.v-theme--dark .heading-title {
  background: linear-gradient(90deg, #64b5f6, #bbdefb);
}

.v-theme--dark .heading-text {
  color: rgba(255, 255, 255, 0.9);
}

.v-theme--dark .sub-text {
  color: rgba(255, 255, 255, 0.7);
}

/* Animation Effects */
.heading-title {
  position: relative;
  display: inline-block;
}

.heading-title::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background: linear-gradient(90deg, #565a6e00, #0867b4c2);
  border-radius: 3px;
}

.v-theme--dark .heading-title::after {
  background: linear-gradient(90deg, #64b5f6, #bbdefb);
}

/* Responsive Styles */
@media (max-width: 960px) {
  .heading-row {
    margin-bottom: 3rem;
  }
  
  .heading-title {
    font-size: 2.2rem;
  }
  
  .heading-text {
    font-size: 1.1rem;
  }
}

@media (max-width: 600px) {
  .heading-row {
    margin-bottom: 2rem;
  }
  
  .heading-title {
    font-size: 1.8rem;
    margin-bottom: 1rem;
  }
  
  .heading-text {
    font-size: 1rem;
  }
  
  .sub-text {
    font-size: 0.9rem;
    margin-top: 0.75rem;
  }
  
  .heading-title::after {
    width: 60px;
    bottom: -6px;
  }
}
</style>